module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "title": 'Book Virtual Classroom Visit',
      "size": 'xl',
      "disableOutsideClick": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('body', {
    staticClass: "px-7 overflow-auto"
  }, [_c('div', {
    staticClass: "my-7 flex justify-center font-semibold text-base"
  }, [_vm._v("\n      Request a virtual classroom visit and have a Parlay Instructional\n      Strategist facilitate a RoundTable with your class.\n    ")]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hubspotForm"
    }
  })
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-7952c91c!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/support_&_PD/components/virtualClassVisitModal.vue
// module id = 2323
// module chunks = 61